import { useEffect, useState } from "preact/hooks";
import { useLocation } from "preact-iso";
import api from "../services/api";
import HiddenCreateTrigger from "../components/HiddenCreateTrigger";
import classnames from "classnames";

import style from "./PostList.scss";

type Post = {
  id: number;
  title: string;
  content: string;
  created_at: string;
  updated_at: string;
};

export default function PostList() {
  const { route } = useLocation();
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // 简单的摘要提取（去掉常见 Markdown 符号后截断）
  const getExcerpt = (text: string, max = 120) => {
    if (!text) return "";
    const rough = text
      .replace(/[`*_>#\-]+/g, " ")
      .replace(/!\[[^\]]*\]\([^\)]*\)/g, " ") // images
      .replace(/\[[^\]]*\]\([^\)]*\)/g, " ") // links
      .replace(/\s+/g, " ")
      .trim();
    return rough.length > max ? `${rough.slice(0, max)}...` : rough;
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get<Post[]>("/api/posts");
        setPosts(res.data);
      } catch (e: any) {
        setError(e?.message || "加载失败");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <div>加载中...</div>;
  if (error) return <div>错误：{error}</div>;

  return (
    <div className={classnames(style.container, style.postListPage)}>
      <div className={style.pageHeader}>
        <h2>博客</h2>
      </div>

      {posts.length === 0 ? (
        <div className={style.emptyState}>暂无博客，试着创建第一篇吧。</div>
      ) : (
        <ul className={style.postList}>
          {posts.map((post) => (
            <li key={post.id} className={style.postCard}>
              <a className={style.title} href={`/post/${post.id}`}>{post.title}</a>
              <div className={style.meta}>创建时间：{new Date(post.created_at).toLocaleString()}</div>
              {post.content && (
                <div className={style.excerpt}>{getExcerpt(post.content)}</div>
              )}
            </li>
          ))}
        </ul>
      )}

      <HiddenCreateTrigger onTrigger={() => route("/create")} />
    </div>
  );
}
